import { JobPost } from "@prisma/client";

export const getIsApproved = (jobPost: JobPost) => {
  return !!jobPost.approvedAt && jobPost.approvedAt < new Date();
};
